import UI from "./base/UI";
import { isA11yCheckVersion, isA11yRectList, isA11yRecListItem } from "../functions/a11y.ui";

/**
 * DeleteList
 */

 /**
#### HTML 구조 및 Data 속성 참고 페이지
** [http://172.20.160.28:9700/kbank_html_mmk/pbk/html/trn/PBKTRN1100000301S.html](http://172.20.160.28:9700/kbank_html_mmk/pbk/html/trn/PBKTRN1100000301S.html)
*/
class DeleteList extends UI {
    defaults = {
        buttonWidth: 0
    };

    constructor(el, options) {
        super('DeleteList', el);

        this.init(el, options);
    }

    init(el, options) {
        this.defaults = {...this.defaults, ...this.parseOptions(options)};
        
        this.render();
    }

    render() {
        this.defaults.buttonWidth = this.$el.find('.ui-del-button').outerWidth(true);
        this.slideEvent();
        this.delButtonEvent();
        this.likeButtonEvent();

        /*! s: FETASK-a11y page 팝업 셀렉트 속성 및 focus로직 v.1.0.0 */
        if(isA11yCheckVersion()){
            isA11yRectList();
            isA11yRecListItem();
        }
        /*! e: FETASK-a11y page 팝업 셀렉트 속성 및 focus로직 v.1.0.0 */
    }
    slideEvent() {
        const that = this;
        const $lists = this.$el.find('.ui-del-list');
        const $items = this.$el.find('.ui-del-item');
        let startX, startY, moveX, moveY, _direction, _thisPosTop, moveEndX, isDrag = false;
        let _$this, $item;
        $lists
        .on('touchstart.delStart', function(e){
            $(this).closest('.page-inner-scroll').css({
                'overflow-y':'auto',
                'height':'100%'
            })
            _$this = $(this);
            $item = _$this.find('.ui-del-item');
            startX = e.originalEvent.touches[0].clientX;
            startY = e.originalEvent.touches[0].clientY;
            _thisPosTop = _$this.offset().top;
            _direction = '';
            $item.css('transition', 'all 0.1s');
            if (!$(e.target).hasClass('ui-del-button') && !$(e.target).closest('.ui-del-item').hasClass('moved')) {
                that.moveListHide($items)
            }
            
        })
        .on('touchmove.delMove', function(e){
            moveX = e.originalEvent.touches[0].clientX - startX;
            moveY = e.originalEvent.touches[0].clientY - startY;
            
            if (_direction == '') {
                if (_thisPosTop == $(this).offset().top && Math.abs(moveX) > Math.abs(moveY) ) {
                    _direction = 'x'
                    $(this).closest('.page-inner-scroll').css('overflow-y','hidden')
                }else{
                    _direction = 'y'
                    $lists.addClass('scroll')
                }
            }
            if (!$lists.hasClass('scroll') && $(this).find('.ui-del-button').length != 0) {
                $item.addClass('active');
                if($item.hasClass('moved')){
                    moveEndX = moveX > that.defaults.buttonWidth ? 0 : (that.defaults.buttonWidth - moveX) *-1;
                    $item.css('transform', 'translateX('+ moveEndX +'px)')
                    if (moveX < 0){
                        $item.css('transform', 'translateX('+ that.defaults.buttonWidth*-1 +'px)')
                    }
                } else if (moveX > 0 ) {
                    $item.css('transform', 'translateX(0px)')
                } else{
                    moveEndX = moveX < (that.defaults.buttonWidth*-1) ? (that.defaults.buttonWidth*-1) : moveX;
                    $item.css('transform', 'translateX(' + moveEndX + 'px)')
                }
            }
        })
        .on('touchend.delEnd', function(e){
            if ($(this).find('.ui-del-button').length == 0){
                moveX = 0;
                moveY = 0;
                $(this).closest('.page-inner-scroll').removeAttr('style')
                $item.remove('active');
                $(this).closest('.page-inner-scroll').css({
                    'overflow-y':'auto',
                    'height':'100%'
                })
                if ($lists.hasClass('scroll')) {
                    $lists.removeClass('scroll');
                    moveX = 1; 
                }
            } else {
                if ($lists.hasClass('scroll')) {
                    $lists.removeClass('scroll');
                    moveX = 1;
                }
                if (moveX != undefined && moveX != 0) {
                    if (moveX > 0) {
                        // right
                        that.moveListHide($item)
                    } else if (moveEndX > (that.defaults.buttonWidth/3*-1)) {
                        that.moveListHide($item)
                    } else {
                        that.moveListHide($items)
                        that.moveListShow($item, that.defaults.buttonWidth)
                    }
                    moveX = 0;
                    moveY = 0
                }
                $(this).closest('.page-inner-scroll').removeAttr('style')
                $item.remove('active');
                $(this).closest('.page-inner-scroll').css({
                    'overflow-y':'auto',
                    'height':'100%'
                })
            }
            
        })
    }

    delButtonEvent() {
        const that = this; 
        const $delButtonthis = this.$el.find('.ui-del-button');
        let $item;
        $delButtonthis
        .on('focus', function(e){
            const _$this = $(this);
            $item = _$this.siblings('.ui-del-item');
            if(!$item.hasClass('moved')){
                that.moveListShow($item, 'focus')
            }
        })
        .on('blur', function(e){
            that.moveListHide($item)
        })
    }
    likeButtonEvent() {
        const that = this;
        const $delButtonthis = this.$el.find('.input-checkbox.like input');
        $delButtonthis.on('change', function(){
            const $item = that.$el.find('.ui-del-item');
            if($item.hasClass('moved')){
                that.moveListHide($item)
            }
        })
    }
    scrollEvent() {
        const that = this;
        const $items = that.$el.find('.ui-del-item');
        let _disappear =false;
        this.$el.closest('.page-inner-scroll').on('scroll', function(){
            if (_disappear == false) {
                that.moveListHide($items);
                _disappear = true;
            } else {
            }
        })
    }
    moveListShow(element,type) {
        const _transition = type === 'focus' ?  'all 0.5s ease' : 'all 0.3s ease'
        element.css({
            'transition':  _transition,
            'transform': `translateX(-${this.defaults.buttonWidth}px)`,
        }).addClass('moved');
        this.scrollEvent();
    }

    moveListHide(element, type) {
        element.css({
            'transition': 'all 0.4s ease',
            'transform': 'translateX(0px)',
        }).removeClass('moved active');
    }
    /**
     *  리스트 삭제 후 이벤트
     * @param {function} callback   리스트 삭제 이후 콜백 함수
     * @example 
     * $('.ui-deleteList').data('ui').deleteAftercallBack(function(){});
     */
    deleteAftercallBack(callback) {
        this.callback = callback;
    }
    deleteCallBackAction() {
        if (this.callback && $.isFunction(this.callback)) {
            this.callback(this);
        }
    }
    getButtonWidth () {
        this.defaults.buttonWidth = this.$el.find('.ui-del-button').outerWidth(true);
    }
    deleteAfterEvent (delButton,check) {
        if (check == true) {
            delButton.parents('.ui-del-list').css('opacity', 0).stop().animate({
                height: 0,
            }, 200, () => {
                delButton.parents('.ui-del-list').remove();
            });
        } else {
            this.moveListHide(delButton.siblings('.ui-del-item'));
        }
    }
}

export default DeleteList;